import axios from "axios";
import { useEffect, useState } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u || "");

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x.field ? `${x.field.split(".").pop()}: ${x.msg}` : x.msg)).join(" · ");
  return fallback;
};

export function useApi(path) {
  const [state, setState] = useState({ data: null, error: null, loading: true });
  useEffect(() => {
    if (!path) return;
    let off = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    api.get(path)
      .then((r) => !off && setState({ data: r.data, error: null, loading: false }))
      .catch((e) => !off && setState({ data: null, error: e, loading: false }));
    return () => { off = true; };
  }, [path]);
  return state;
}

export const PRICING_MODELS = [
  { value: "free", label: "Free" },
  { value: "freemium", label: "Free plan + paid tiers" },
  { value: "free_trial", label: "Free trial" },
  { value: "paid", label: "Paid" },
  { value: "custom", label: "Custom / quote" },
];
export const pricingLabel = (v) => PRICING_MODELS.find((p) => p.value === v)?.label || "Not specified";

export const USE_CASES = ["Startups", "Freelancers", "Small Businesses", "Mid-Market", "Enterprise", "Remote Teams", "E-commerce Sellers", "Agencies"];
export const BLOG_CATEGORIES = ["SaaS Guides", "Software Reviews", "Business Technology", "Productivity", "AI Tools", "Startup Resources"];

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
};

export const outbound = (s) => ({
  href: s.affiliate_url || s.website_url,
  rel: s.affiliate_url ? "sponsored nofollow noopener noreferrer" : "noopener noreferrer",
  target: "_blank",
});
